"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeToken = decodeToken;

function decodeToken(token) {
  if (!token) throw new Error("The token must be a non-empty value");
  var base64Split = token.split(".");
  if (base64Split.length < 2) throw new Error("Unable to decode token.");
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(window.atob(base64));
}